'use client';
import { ReactNode } from 'react';
import cn from 'classnames';
import { LinkProps, LinkWrapper } from '@intigral/shared/components/LinkWrapper';
import { FontIcon } from '@intigral/shared';
import { FontIconName } from '@intigral/shared/components/FontIcon';
import styles from './bottomtabbar.module.sass';

export interface BottomTabItem extends LinkProps {
    /** already localized */
    label: string;
    /** ignored when `media` is set */
    icon?: FontIconName;
    media?: ReactNode;
    isActive?: boolean;
}

interface BottomTabBarProps {
    items: BottomTabItem[];
    ariaLabel?: string;
    className?: string;
}

/** hidden at $medium by CSS, not useMediaQuery */
export const BottomTabBar = ({ items, ariaLabel = 'Main', className }: BottomTabBarProps) => {
    if (!items?.length) return null;

    return (
        <nav className={cn(styles.bar, className)} aria-label={ariaLabel}>
            {items.map((item, index) => (
                <LinkWrapper
                    key={`${item.href}-${index}`}
                    link={item}
                    className={cn(styles.tab, item.isActive && styles.active)}
                    aria-current={item.isActive ? 'page' : undefined}
                >
                    <span className={styles.media}>
                        {item.media ?? (item.icon && <FontIcon name={item.icon} size="smaller" md="smaller" />)}
                    </span>
                    <span className={styles.label}>{item.label}</span>
                </LinkWrapper>
            ))}
        </nav>
    );
};
